module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggle",
    class: {
      toggled: _vm.$sidebar.showSidebar
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleSidebar
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v(_vm._s(_vm.$t("navbar.Toggle navigation")))]), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar1"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar2"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar bar3"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse"
  }, [_c('ul', {
    staticClass: "nav navbar-nav navbar-main"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.Projects")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/inputs"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.Inputs")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/scenarios"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.Scenarios")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/optimizations"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.Optimizations")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('router-link', {
    attrs: {
      "to": "/geospatial"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("navbar.Geospatial")))])])], 1), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": "http://optimamodel.com/docs/Optima%20Nutrition%20Input%20Data_Jan2022.pdf",
      "target": "_blank"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t("Parameters")))])])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link"
  }, [_c('i', {
    staticClass: "ti-view-grid"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("navbar.Project")) + ": " + _vm._s(_vm.activeProjectName))])])]), _vm._v(" "), _c('dropdown', {
    scopedSlots: _vm._u([{
      key: "title",
      fn: function() {
        return [_c('div', {
          staticClass: "dropdown-title"
        }, [_c('i', {
          staticClass: "ti-user dropdown-icon"
        }), _vm._v("\n              " + _vm._s(_vm.$t("navbar.User")) + ": " + _vm._s(_vm.activeUserName) + "\n              "), _c('b', {
          staticClass: "caret"
        })])]
      },
      proxy: true
    }])
  }, [_vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/changeinfo"
    }
  }, [_c('i', {
    staticClass: "ti-pencil"
  }), _vm._v("  " + _vm._s(_vm.$t("navbar.Edit account")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/changepassword"
    }
  }, [_c('i', {
    staticClass: "ti-key"
  }), _vm._v("  " + _vm._s(_vm.$t("navbar.Change password")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/help"
    }
  }, [_c('i', {
    staticClass: "ti-help"
  }), _vm._v("  " + _vm._s(_vm.$t("navbar.Help")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/about"
    }
  }, [_c('i', {
    staticClass: "ti-shine"
  }), _vm._v("  " + _vm._s(_vm.$t("navbar.About")))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.logOut()
      }
    }
  }, [_c('i', {
    staticClass: "ti-car"
  }), _vm._v("  " + _vm._s(_vm.$t("navbar.Log out")))])])]), _vm._v(" "), ((_vm.projectLocale !== undefined) && (_vm.projectLocale !== _vm.uiLocale)) ? _c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link"
  }, [_c('i', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    staticClass: "ti-alert",
    attrs: {
      "title": _vm.$t('navbar.language_warning')
    }
  })])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [_c('div', {
    staticClass: "nav-link"
  }, [_c('LocaleSwitcher')], 1)])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    attrs: {
      "href": "http://ocds.co",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/optima-logo-nutrition.png",
      "height": "50px",
      "vertical-align": "middle",
      "alt": ""
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63e81c8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/Navbar.vue
// module id = 383
// module chunks = 1